import script from "./catalogue-complete.vue?vue&type=script&setup=true&lang=js"
export * from "./catalogue-complete.vue?vue&type=script&setup=true&lang=js"

import "./catalogue-complete.vue?vue&type=style&index=0&id=091cb10e&scoped=true&lang=css"

import exportComponent from "/Users/mikemorales/Sites/firebird/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-091cb10e"]])

export default __exports__